// Scroll-to-dock state shared between OverviewTab and page header
import { createContext, useContext, useRef, useState, type ReactNode, type RefObject } from 'react'

interface DockState {
  /** Whether the overview tab's local time selector has been docked (scrolled past) */
  isDocked: boolean
  setIsDocked: (value: boolean) => void
  /** Ref to the inline portal target in the page header row (controls + energy types) */
  dockTargetRef: RefObject<HTMLDivElement | null>
  /** Ref to the full-width portal target below the header (range slider) */
  dockSliderRef: RefObject<HTMLDivElement | null>
}

const DockContext = createContext<DockState | null>(null)

export function DockProvider({ children }: { children: ReactNode }) {
  const [isDocked, setIsDocked] = useState(false)
  const dockTargetRef = useRef<HTMLDivElement | null>(null)
  const dockSliderRef = useRef<HTMLDivElement | null>(null)
  return (
    <DockContext.Provider value={{ isDocked, setIsDocked, dockTargetRef, dockSliderRef }}>
      {children}
    </DockContext.Provider>
  )
}

export function useDock(): DockState {
  const ctx = useContext(DockContext)
  if (!ctx) {
    throw new Error('useDock must be used inside DockProvider')
  }
  return ctx
}
